import React, { FC, memo } from 'react';
import BusyModeModal from 'components/Modals/BusyModeModal';
import EnableModal from './EnableModal';
import {
  Container,
  Header,
  Title,
  CloseIcon,
  BrandsContainer,
  BrandStatus,
  SubHeader,
  BusyModeBlock,
  SubTitle,
  Text,
  Button,
} from './styles';
import { Props } from './types';
import useConnect from './connect';

const DrawerStatus: FC<Props> = ({ handleCloseStatus, openStatus }) => {
  const {
    isLoading,
    brands,
    handleOpenModal,
    handleCloseModal,
    isModalOpen,
    handleOpenEnableModal,
    handleCloseEnableModal,
    isEnableModalOpen,
  } = useConnect();

  return (
    <Container
      anchor="right"
      open={openStatus}
      onClose={handleCloseStatus}
      disableEnforceFocus
    >
      <Header>
        <Title>Status</Title>
        <CloseIcon onClick={handleCloseStatus} />
      </Header>
      <SubHeader>
        <BusyModeBlock>
          <SubTitle>Instant Busy Mode</SubTitle>
          <Text>Apply busy hours to all virtual brands & channels</Text>
        </BusyModeBlock>
        <Button
          type="button"
          variant="hard-outlined"
          color="blank"
          onClick={handleOpenModal}
        >
          Add busy hours
        </Button>
      </SubHeader>
      <SubHeader>
        <BusyModeBlock>
          <SubTitle>Enable All</SubTitle>
          <Text>Enabled all channels at once</Text>
        </BusyModeBlock>
        <Button
          type="button"
          variant="filled"
          color="primary"
          onClick={handleOpenEnableModal}
        >
          Enable All
        </Button>
      </SubHeader>
      <BrandsContainer>
        {!isLoading &&
          brands.map((brand) => <BrandStatus key={brand.id} brand={brand} />)}
      </BrandsContainer>
      {isModalOpen && <BusyModeModal open handleClose={handleCloseModal} />}
      {isEnableModalOpen && (
        <EnableModal open handleClose={handleCloseEnableModal} />
      )}
    </Container>
  );
};

export default memo(DrawerStatus);

// TODO: TFR-44 move to status group
